<template>
  <div class="mt-3">
    <router-link :to="backRoute" class="btn btn-secondary btn-sm mb-3">
      <i class="fal fa-arrow-left" />
      {{ trans("admin.cdr.backToFlags") }}
    </router-link>

    <clip-loader v-if="loading" />

    <cdr-flag-info v-if="!loading && flag" :flag="flag">
      <template #actions>
        <button
          v-if="dismissal && dismissal.mode === cdrExecutionMode.FORM"
          type="button"
          class="btn btn-outline-secondary btn-sm"
          @click="dismissDialogOpen = true"
        >
          {{ trans("admin.cdr.dismissFlag") }}
        </button>
      </template>
    </cdr-flag-info>

    <template v-if="!loading && flag && verification">
      <cdr-verification-form
        v-if="verification.mode === cdrExecutionMode.FORM"
        :flag="flag"
        :api-url="apiUrl"
        @updated="applyResponse"
      />
      <cdr-verification-resolved v-else :verification="verification" />
    </template>

    <template v-if="!loading && flag && execution">
      <cdr-deletion-form
        v-if="
          execution.kind === cdrRequestedAction.DELETION &&
          execution.mode === cdrExecutionMode.FORM
        "
        :flag="flag"
        :execution="execution"
        :api-url="apiUrl"
        @updated="applyResponse"
      />
      <cdr-deletion-resolved
        v-else-if="execution.kind === cdrRequestedAction.DELETION"
        :execution="execution"
      />
      <cdr-reassignment-form
        v-else-if="
          execution.kind === cdrRequestedAction.REASSIGNMENT &&
          execution.mode === cdrExecutionMode.FORM
        "
        :flag="flag"
        :execution="execution"
        :api-url="apiUrl"
        @updated="applyResponse"
      />
      <cdr-reassignment-resolved
        v-else-if="execution.kind === cdrRequestedAction.REASSIGNMENT"
        :flag="flag"
        :execution="execution"
      />
    </template>

    <cdr-dismissal-resolved
      v-if="
        !loading &&
        flag &&
        dismissal &&
        dismissal.mode === cdrExecutionMode.READONLY
      "
      :dismissal="dismissal"
    />

    <cdr-dismissal-dialog
      v-if="!loading && flag && dismissal"
      :show="dismissDialogOpen"
      :flag="flag"
      :api-url="apiUrl"
      @close="dismissDialogOpen = false"
      @updated="applyResponse"
    />

    <div v-if="!loading && auditEvents.length > 0" class="card mt-3">
      <div class="card-body">
        <h5 class="card-title">
          {{ trans("admin.cdr.auditLog") }}
        </h5>

        <div class="table-responsive">
          <table class="table table-hover">
            <thead class="sortable-table-header">
              <tr>
                <th>{{ trans("admin.cdr.auditAction") }}</th>
                <th>{{ trans("admin.cdr.actor") }}</th>
                <th>{{ trans("admin.cdr.createdAt") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="event in auditEvents" :key="event.id">
                <td>{{ event.action_label }}</td>
                <td>{{ event.actor?.full_name }}</td>
                <td>{{ event.created_at_formatted }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClipLoader from "../Utils/ClipLoader.vue";
import CdrFlagInfo from "./CdrFlagInfo.vue";
import CdrVerificationForm from "./CdrVerificationForm.vue";
import CdrVerificationResolved from "./CdrVerificationResolved.vue";
import CdrDeletionForm from "./CdrDeletionForm.vue";
import CdrDeletionResolved from "./CdrDeletionResolved.vue";
import CdrReassignmentForm from "./CdrReassignmentForm.vue";
import CdrReassignmentResolved from "./CdrReassignmentResolved.vue";
import CdrDismissalDialog from "./CdrDismissalDialog.vue";
import CdrDismissalResolved from "./CdrDismissalResolved.vue";
import { practitionerHttpService } from "../../app/practitioner-portal/store/practitioner-http-service";
import { CDR_EXECUTION_MODE, CDR_REQUESTED_ACTION } from "./cdr-constants";

export default {
  components: {
    ClipLoader,
    CdrFlagInfo,
    CdrVerificationForm,
    CdrVerificationResolved,
    CdrDeletionForm,
    CdrDeletionResolved,
    CdrReassignmentForm,
    CdrReassignmentResolved,
    CdrDismissalDialog,
    CdrDismissalResolved,
  },
  props: {
    apiUrl: { type: String, required: true },
    backRoute: { type: String, required: true },
  },
  data() {
    return {
      loading: true,
      flag: null,
      auditEvents: [],
      verification: null,
      execution: null,
      dismissal: null,
      dismissDialogOpen: false,
      cdrExecutionMode: CDR_EXECUTION_MODE,
      cdrRequestedAction: CDR_REQUESTED_ACTION,
    };
  },
  created() {
    this.getFlag();
  },
  methods: {
    getFlag() {
      this.loading = true;
      practitionerHttpService
        .get(this.apiUrl + this.$route.params.id)
        .then((res) => {
          this.applyResponse(res.data);
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.userErrorMessage(error);
        });
    },
    applyResponse(data) {
      this.flag = data.flag;
      this.auditEvents = data.audit_events;
      this.verification = data.verification ?? null;
      this.execution = data.execution ?? null;
      this.dismissal = data.dismissal ?? null;
    },
  },
};
</script>
